/** Stored on `User.role` in API responses — only these three values. */
export enum AppUserRole {
  SUPER_ADMIN = 'super_admin',
  SHELTER_ADMIN = 'shelter_admin',
  USER = 'user',
}

/** Stored on `User.shelterRole` (different field, not `AppUserRole`). */
export enum ShelterRosterRole {
  ADMIN = 'admin',
  MEMBER = 'user',
}
